import { type QuickRebuttal } from "@expert/contentful";
import { addGenericMessage } from "@soluto-private/expert-workspace-timeline";
import { useCallback } from "react";

import { usePanelsStore } from "@/panels/modules/panels/store/panels.store";
import { useProductOfferStore } from "@/sales-tools";
import { formatQuickRebuttal } from "@/sales-tools/product-sale-flow/useProductSaleFlow.helpers";
import { useSessionId } from "@/sdk";

export const useProductSaleFlow = () => {
    const sessionId = useSessionId();

    const panelsStore = usePanelsStore();
    const selectedProduct = useProductOfferStore((state) => state.getSelectedProduct(sessionId));
    const updateSelectedProduct = useProductOfferStore((state) => state.updateSelectedProduct);

    const selectedProductInfo = selectedProduct?.productSku
        ? useProductOfferStore.getState().getProductInfo(sessionId, selectedProduct.productSku)
        : undefined;
    const productSaleFlowPanelTitle = selectedProductInfo?.displayName ?? "Product Sale";

    const handleProductSaleClose = useCallback(() => {
        updateSelectedProduct(sessionId, undefined);
    }, [sessionId, updateSelectedProduct]);

    const addQuickRebuttalToExpertAssistTimeline = (quickRebuttal?: QuickRebuttal) => {
        addGenericMessage(sessionId, formatQuickRebuttal(quickRebuttal));
        panelsStore.setSelectedTab("rightBottom")("a");
    };

    return {
        handleProductSaleClose,
        addQuickRebuttalToExpertAssistTimeline,
        productSaleFlowPanelTitle,
        selectedProduct,
        selectedProductInfo,
    };
};
